<template>
  <!-- <el-card> -->
    <div class="vd_search_group vg_mtb_16">
      <el-form :inline="true" size="min" :model="searchForm" ref="searchForm" @keyup.enter.native="getPpotsNow()">
        <el-row>
          <el-col :md="7">
            <el-form-item label="合同编号：">
              <el-input size="small" v-model.trim="searchForm.pcon_no" clearable placeholder="请填写合同编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="7">
            <el-form-item label="产品货号：">
              <el-input size="small" v-model.trim="searchForm.prod_no" clearable placeholder="请填写产品编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="7">
            <el-form-item label="产品名称：">
              <el-input size="small" v-model.trim="searchForm.prod_name" clearable placeholder="请填写产品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="3">
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="getPpotsNow()" class="vg_ml_16">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="vd_mar15">
        <el-button size="mini" type="danger" @click="cancel">取消选择</el-button>
        <el-button size="mini" type="primary" @click="confirmIn()">确认选择</el-button>
      </el-row>
      <el-row>
        <el-col :md="24">
          <el-table class="vg_pointer" ref="multiTable" :data="tableData" @selection-change="handleSelectionChange" :row-key="getRowKey" border>
            <el-table-column type="selection" width="48"  align="center" :reserve-selection="true"/>
            <el-table-column label="合同编号" prop="pcon_no" />
            <el-table-column label="产品货号" prop="prod_no" />
            <el-table-column label="产品名称" prop="prod_name" />
            <el-table-column label="计划出库" prop="pcon_prod_num"/>
            <el-table-column label="实出库数" prop="ppot_num"/>
            <!-- <el-table-column label="待出库时间" prop="ppot_date" :formatter="formatDate" />
            <el-table-column label="核销状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="getStatusName(scope.row.ppot_full).type" size="mini">{{getStatusName(scope.row.ppot_full).name}}</el-tag>
              </template>
            </el-table-column> -->
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="24">
          <pubPagination :totalPage = 'totalPage' @changePageSearch = "changePageSearch" ref="pubPagination"></pubPagination>
        </el-col>
      </el-row>
  </div>
  <!-- </el-card> -->
</template>

<script>
import {get} from "@api/request";
import {ppotAPI} from "@api/modules/ppot"
import pubPagination from "@/components/common/pubPagination";

export default{
  name:"PodrEditIn",
  components:{
    pubPagination
  },
  props:{
  },
  data(){
    return{
      tableData:[],
      searchForm: {
        pcon_no:'',
        prod_no:'',
        prod_name:'',
      },
      totalPage:0,
      btn:{},
      loading: true,
      multiSelection: [],
      currentPage:1,
      flag:false,
      ppotTypeGroupOpt:[],
    }
  },
  created(){
    this.initData()
  },
  methods:{
    initData(){
      this.getPpotsList()
    },
    // 获取样品信息
    getPpotsList() {
      get(ppotAPI.getPpots,
        {
          pcon_no: this.searchForm.pcon_no,
          prod_no: this.searchForm.prod_no,
          prod_name: this.searchForm.prod_name,
          ppot_full: 0,
          page_no: this.currentPage,
        })
        .then(res => {
          if(res.data.code === 0){
            this.tableData = res.data.data.list;
            this.totalPage = res.data.data.total;
            this.btn = res.data.data.btn;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({message:mg,type:tp});
          }
        })
        .catch(res=>{
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({message:mg,type:tp});
        })
    },
    // 时间转换
    formatDate(row) {
      return this.helper.toStringDate(row.create_time)
    },
    // 查询方法
    getPpotsNow(){
      this.$refs.pubPagination.currentPage = 1
      this.currentPage = 1
      this.getPpotsList()
    },
    // 清空
    clear(){
      this.$refs.multiTable.clearSelection();
    },
    // 指定一个key标识这一行的数据
    getRowKey (row) {
      return row.ppot_id;
    },
    // 多选
    handleSelectionChange(val){
      this.multiSelection = val;
    },
    // 取消选择
    cancel(){
      this.clear()
    },
    // 确认选择
    confirmIn(){
      this.$emit("confirmIn",this.multiSelection)
    },
    // 分页查询
    changePageSearch(val){
      this.currentPage = val
      this.getPpotsList()
    },
  }
}
</script>

<style lang="scss" scoped>
.vd_elimg {
  width: 60px;
  height: 60px;
}
.vd_mrt{
  margin-top: 20px;
}
.vd_mar15{
  margin: 15px 0;
}
</style>
